import {
  Headings,
  Button,
  Image,
  Paragraph,
  Label,
  VirtualIcon,
  ChatMinimizeIcon,
} from '@sentara-health/optimahealth_web';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import physicalTherapy from '../../assets/images/physicalTherapy.svg';
import {
  navigateToExternalUrl,
} from 'common';
import { isAvMed,GlobalContext } from '../../context';

function PhysicalTherapy() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { ssoEndPoints } = useContext(GlobalContext);

  const openUrl = (url: string | undefined) => {
    window.open(url, isAvMed() ? '_blank' : '_self');
  };

  // Redirect to SSO URL 
  const redirectUrl = (urltype:string,type:string) => {
    if (isAvMed()){
      openUrl(urltype);
    }else{
       navigate(type) ;
    } 
  };

  return (
    <div>
      <Button
        iconLeft={<ChatMinimizeIcon />}
        data-testid="back"
        variant="icon_btn"
        onClick={() => redirectUrl(ssoEndPoints?.VirtualVisitSSO,ssoEndPoints?.virtualVisitUrl)}
        aria-label={t('physicalTherapy.backButton') || 'Back'}
      >
        {t('physicalTherapy.title')}
      </Button>
      <div className="row py-4">
        <div className="col-md-6">
          <Image
            dataTestId="physicalTherapyImage"
            className="rounded-4 w-100"
            path={physicalTherapy}
          />
        </div>
        <div className="d-flex flex-column col-md-6 mt-3 mt-md-0">
          <Headings
            level={2}
            text={t('physicalTherapy.physicalTherapy')}
            variant="semiBold"
            dataTestId="physicalTherapyHeaderLabel"
          />
          <span className="d-inline-block my-2">{<VirtualIcon />}</span>
          <Paragraph text={t('physicalTherapy.physicalTherapyContent')} variant="regular" dataTestId="physicalTherapyContent" className="mt-2" />
          <div className="d-flex align-items-center mt-1">
            <Button
              className="d-flex justify-content-end btn-md-height"
              data-testid="schedulePhysicalTherapyAppointment"
              variant="primary_btn"
              onClick={() => {
                navigateToExternalUrl(ssoEndPoints?.PHYSICAL_THERAPY_URL);
              }}
            >
              {t('virtualVisitCare.scheduleAppointment')}
            </Button>
          </div>
        </div>
      </div>
      <div className="d-flex flex-column my-2">
        <Headings
          level={5}
          text={t('physicalTherapy.rehabTherapy')}
          variant="semiBold"
          dataTestId="physicalRehabTherapyHeaderLabel"
        />
        <ul className="custom-list">
          <li>
            <Label>{t('physicalTherapy.skilledProviders')}</Label>
            <span className="font-size-16 ms-1">
              {t('physicalTherapy.skillProviderContent')}
            </span>
          </li>
          <li>
            <Label>{t('physicalTherapy.collaborativeCare')}</Label>
            <span className="font-size-16 ms-1">
              {t('physicalTherapy.collaborativeCareContent')}
            </span>
          </li>
          <li>
            <Label>
              {t('physicalTherapy.convenientTherapySessions')}
            </Label>
            <span className="font-size-16 ms-1">
              {t('physicalTherapy.convenientTherapySessionsContent')}
            </span>
          </li>
        </ul>
        <span className="font-size-16 ms-1 mt-5 italic-style">
          {t('physicalTherapy.physicalTherapyDisclaimerContent')}
        </span>
      </div>
    </div>
  );
}

export default PhysicalTherapy;